import React, { useEffect, useState } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { mailPattern, phoneNumber } from "../../variables/constants";
import toast from "react-hot-toast";
import { putServices } from "../../apiServices/apiServices";

function UpdateController() {
  const [fieldData, setFieldData] = useState({
    co_person: "",
    co_person_no: "",
    co_person_email: "",
    pincode: "",
    district: "",
    state: "",
  });
  const [isValid, setIsValid] = useState({
    co_person_email: true,
    co_person_phone: true,
  });
  const [normalEmail, setNormalEmail] = useState(["", "", "", "", ""]);
  const [normalPhone, setNormalPhone] = useState(["", "", "", "", ""]);
  const [criticalEmail, setCriticalEmail] = useState(["", "", ""]);
  const [criticalPhone, setCriticalPhone] = useState(["", "", ""]);
  const [loading, setLoading] = useState(false);
  const location = useLocation().state;
  const navigate = useNavigate();
  const access_token = localStorage.getItem("gassol-admin-token");

  useEffect(() => {
    setFieldData({
      ...fieldData,
      co_person: location?.controller_data?.co_person ?? "",
      co_person_no: location?.controller_data?.co_person_no?.slice(3) ?? "",
      co_person_email: location?.controller_data?.co_person_email ?? "",
      pincode: location?.controller_data?.pincode ?? "",
      district: location?.controller_data?.district ?? "",
      state: location?.controller_data?.state ?? "",
    });
    setNormalEmail(
      location?.controller_data?.communication?.normal_email ?? [
        "",
        "",
        "",
        "",
        "",
      ]
    );
    setNormalPhone(
      (
        location?.controller_data?.communication?.normal_phone ?? [
          "",
          "",
          "",
          "",
          "",
        ]
      ).map((phone) => (phone.startsWith("+91") ? phone.substring(3) : phone))
    );
    setCriticalEmail(
      location?.controller_data?.communication?.critical_email ?? ["", "", ""]
    );
    setCriticalPhone(
      (
        location?.controller_data?.communication?.critical_phone ?? ["", "", ""]
      ).map((phone) => (phone.startsWith("+91") ? phone.substring(3) : phone))
    );
  }, []);

  const handleNormalEmailChange = (index, event) => {
    const newEmails = [...normalEmail];
    newEmails[index] = event.target.value;
    setNormalEmail(newEmails);
  };
  const handleNormalPhoneChange = (index, event) => {
    const newPhones = [...normalPhone];
    newPhones[index] = event.target.value.replace(/\D/g, "");
    setNormalPhone(newPhones);
  };
  const handleCriticalEmailChange = (index, event) => {
    const newEmails = [...criticalEmail];
    newEmails[index] = event.target.value;
    setCriticalEmail(newEmails);
  };
  const handleCriticalPhoneChange = (index, event) => {
    const newPhones = [...criticalPhone];
    newPhones[index] = event.target.value.replace(/\D/g, "");
    setCriticalPhone(newPhones);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const urlencoded = new URLSearchParams();

    urlencoded.append("co_person", fieldData.co_person);
    urlencoded.append("co_person_email", fieldData.co_person_email);
    urlencoded.append("co_person_no", "+91" + fieldData.co_person_no);
    urlencoded.append("pincode", fieldData.pincode);
    urlencoded.append("district", fieldData.district);
    urlencoded.append("state", fieldData.state);
    for (let i = 0; i < normalEmail.length; i++) {
      urlencoded.append("normal_email", normalEmail[i]);
    }
    for (let i = 0; i < normalPhone.length; i++) {
      if (normalPhone[i].length > 0) {
        urlencoded.append("normal_phone", "+91" + normalPhone[i]);
      } else {
        urlencoded.append("normal_phone", "");
      }
    }
    for (let i = 0; i < criticalEmail.length; i++) {
      urlencoded.append("critical_email", criticalEmail[i]);
    }
    for (let i = 0; i < criticalPhone.length; i++) {
      if (criticalPhone[i].length > 0) {
        urlencoded.append("critical_phone", "+91" + criticalPhone[i]);
      } else {
        urlencoded.append("critical_phone", "");
      }
    }

    try {
      const res = await putServices(
        `/api/hardware/activate/update?hardware_id=${location?.controller_data?.hardware_id}`,
        urlencoded,
        access_token
      );
      if (res.responseCode === 200) {
        navigate(-1);
        toast.success("Hardware details updated...");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
          <div className="flex gap-3 sm:gap-6">
            <Link
              to={-1}
              className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
            >
              <IoChevronBackOutline />
              <p className="text-base sm:text-xl">Update Hardware</p>
            </Link>
          </div>
        </div>

        <div className="mt-5">
          <form onSubmit={handleSubmit}>
            <>
              <label className="text-[#BDBDBD] mb-5">
                Company/Contact Info
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                <div>
                  <label
                    htmlFor="contactPersonName"
                    className="text-black font-semibold"
                  >
                    Contact Person Name*
                  </label>
                  <input
                    id="contactPersonName"
                    className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                    type="text"
                    placeholder="Contact Person Name"
                    value={fieldData.co_person}
                    onChange={(e) =>
                      setFieldData({
                        ...fieldData,
                        co_person: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="contactPersonName"
                    className="text-black font-semibold"
                  >
                    Contact Person Phone no.*
                  </label>
                  <input
                    id="contactPersonPhone"
                    className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                    type="number"
                    placeholder="Contact Person Phone no."
                    value={fieldData.co_person_no}
                    onChange={(e) => {
                      if (phoneNumber.test(e.target.value.slice(0, 10))) {
                        setIsValid({ ...isValid, co_person_phone: true });
                      } else {
                        setIsValid({ ...isValid, co_person_phone: false });
                      }
                      setFieldData({
                        ...fieldData,
                        co_person_no: e.target.value.slice(0, 10),
                      });
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="contactPersonName"
                    className="text-black font-semibold"
                  >
                    Contact Person Email*
                  </label>
                  <input
                    id="contactPersonEmail"
                    className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                    type="email"
                    placeholder="Contact Person Email"
                    value={fieldData.co_person_email}
                    onChange={(e) => {
                      if (mailPattern.test(e.target.value)) {
                        setIsValid({ ...isValid, co_person_email: true });
                      } else {
                        setIsValid({ ...isValid, co_person_email: false });
                      }
                      setFieldData({
                        ...fieldData,
                        co_person_email: e.target.value,
                      });
                    }}
                    required
                  />
                </div>
              </div>
            </>

            <div className="mt-8">
              <label className="text-[#BDBDBD] mb-5">Company Address</label>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                <div>
                  <label
                    htmlFor="contactPersonName"
                    className="text-black font-semibold"
                  >
                    Location Pincode*
                  </label>
                  <input
                    id="companyPincode"
                    className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                    type="number"
                    placeholder="Pincode"
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                    value={fieldData.pincode}
                    onChange={(e) => {
                      setFieldData({
                        ...fieldData,
                        pincode: e.target.value.slice(0, 6),
                      });
                    }}
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="companyDistrict"
                    className="text-black font-semibold"
                  >
                    Company District*
                  </label>
                  <input
                    id="companyDistrict"
                    className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                    type="text"
                    placeholder="Enter the District"
                    value={fieldData.district}
                    onChange={(e) =>
                      setFieldData({ ...fieldData, district: e.target.value })
                    }
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="companyState"
                    className="text-black font-semibold"
                  >
                    Company State*
                  </label>
                  <input
                    id="companyState"
                    className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                    type="text"
                    placeholder="Enter the State"
                    value={fieldData.state}
                    onChange={(e) =>
                      setFieldData({ ...fieldData, state: e.target.value })
                    }
                    required
                  />
                </div>
              </div>
            </div>

            <div className="mt-8">
              <label className="text-[#BDBDBD] mb-5">Communication info</label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                <div>
                  <label
                    htmlFor="companyPincode"
                    className="text-black font-semibold"
                  >
                    Email for Normal Communication *
                  </label>
                  <div className="flex flex-col gap-3 pt-3">
                    {normalEmail.map((n_email, i) => (
                      <input
                        key={i}
                        id="email"
                        className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                        type="email"
                        placeholder="Enter the Email"
                        value={n_email}
                        onChange={(e) => handleNormalEmailChange(i, e)}
                        required={i === 0}
                      />
                    ))}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="companyPincode"
                    className="text-black font-semibold"
                  >
                    Phone no. for Normal Communication *
                  </label>
                  <div className="flex flex-col gap-3 pt-3">
                    {normalPhone.map((n_phone, i) => (
                      <input
                        key={i}
                        id="phonenumber"
                        className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                        type="tel"
                        placeholder="Enter the Phone no."
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                        value={n_phone}
                        onChange={(e) => handleNormalPhoneChange(i, e)}
                        maxLength={10}
                        required={i === 0}
                      />
                    ))}
                  </div>
                </div>
                <div className="mt-5">
                  <label
                    htmlFor="companyPincode"
                    className="text-black font-semibold"
                  >
                    Email for Critical Communication *
                  </label>
                  <div className="flex flex-col gap-3 pt-3">
                    {criticalEmail.map((c_email, i) => (
                      <input
                        key={i}
                        id="email"
                        className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                        type="email"
                        placeholder="Enter the Email"
                        value={c_email}
                        onChange={(e) => handleCriticalEmailChange(i, e)}
                        required={i === 0}
                      />
                    ))}
                  </div>
                </div>
                <div className="mt-5">
                  <label
                    htmlFor="companyPincode"
                    className="text-black font-semibold"
                  >
                    Phone no. for Critical Communication *
                  </label>
                  <div className="flex flex-col gap-3 pt-3">
                    {criticalPhone.map((c_phone, i) => (
                      <input
                        key={i}
                        id="phonenumber"
                        className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                        type="tel"
                        placeholder="Enter the Phone no."
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                        value={c_phone}
                        onChange={(e) => handleCriticalPhoneChange(i, e)}
                        maxLength={10}
                        required={i === 0}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end items-end my-4">
              <input
                type="submit"
                value={loading ? "Loading..." : "Update"}
                disabled={loading}
                className="w-full md:w-[50%] text-gray-100 px-8 py-7 rounded-2xl outline-none bg-[#BDBDBD] cursor-pointer hover:bg-[#03438D] hover:text-white uppercase disabled:cursor-not-allowed"
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default UpdateController;
